module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loader-overlay",
      rawName: "v-loader-overlay",
      value: (_vm.progressDocs),
      expression: "progressDocs"
    }],
    staticClass: "document"
  }, [_c('iframe', {
    ref: "documentIframe",
    staticClass: "can-scroll",
    attrs: {
      "src": _vm.previewUrl
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('div', {
    staticClass: "status"
  }, [_c('span', [_vm._v(_vm._s('Статус: ' + _vm.statusName))])]), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.document.status == 'ACTUAL') ? _c('div', {
    staticClass: "button-container"
  }, [_c('z-button', {
    staticClass: "document-button",
    attrs: {
      "transperent": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDocDialog = true
      }
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": ['fa', 'envelope']
    }
  }), _vm._v(" "), _c('span', [_vm._v("Отправить по E-mail")])], 1), _vm._v(" "), _c('z-button', {
    staticClass: "document-button",
    attrs: {
      "transperent": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.printDoc()
      }
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": ['fa', 'print']
    }
  }), _vm._v(" "), _c('span', [_vm._v("Распечатать")])], 1), _vm._v(" "), (_vm.document && _vm.document.id && (!_vm.$props.block || _vm.isUserManager)) ? _c('z-button', {
    staticClass: "document-button",
    attrs: {
      "transperent": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateDoc()
      }
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": ['fa', 'arrows-rotate']
    }
  }), _vm._v(" "), _c('span', [_vm._v("Обновить данные")])], 1) : _vm._e(), _vm._v(" "), (_vm.document && _vm.document.id && !_vm.$props.block && _vm.isUserAdmin) ? _c('z-button', {
    staticClass: "document-button",
    attrs: {
      "transperent": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.showEditDialog()
      }
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": ['fa', 'pen']
    }
  }), _vm._v(" "), _c('span', [_vm._v("Редактировать")])], 1) : _vm._e(), _vm._v(" "), (_vm.document && _vm.document.id && !_vm.$props.block && _vm.$props.removable) ? _c('z-button', {
    staticClass: "document-button",
    attrs: {
      "transperent": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.removeDoc()
      }
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": ['fa', 'trash']
    }
  }), _vm._v(" "), _c('span', [_vm._v("Удалить")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.document.status == 'DELETED') ? _c('div', {
    staticClass: "button-container"
  }, [(_vm.document && _vm.document.id && !_vm.$props.block) ? _c('z-button', {
    staticClass: "document-button",
    attrs: {
      "transperent": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.restoreDoc()
      }
    }
  }, [_c('z-icon', {
    attrs: {
      "icon": ['fa', 'trash-arrow-up']
    }
  }, [_vm._v(" restore_from_trash ")]), _vm._v(" "), _c('span', [_vm._v("Восстановить")])], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.document.created_at) ? _c('div', [_c('span', [_vm._v(_vm._s('Дата создания: ' + _vm.moment(_vm.document.created_at).format('DD.MM.YYYY')) + " ")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(' (' + ((_vm.document.creater && _vm.document.creater.login) ? _vm.document.creater.login : 'клиент') + ')'))])]) : _vm._e(), _vm._v(" "), (_vm.document.updated_at) ? _c('div', [(_vm.document.last_print_date) ? _c('span', [_c('span', [_vm._v(_vm._s('Дата последний печати: ' + _vm.moment(_vm.document.last_print_date).format('DD.MM.YYYY')) + " ")]), _vm._v(" "), _c('b', [_vm._v(_vm._s(((_vm.document.last_printer && _vm.document.last_printer.login) ? ' (' + _vm.document.last_printer.login + ')' : ' (клиент)')))])]) : _c('span', [_c('span', [_vm._v(_vm._s('Дата последний печати: '))]), _vm._v(" "), _c('b', [_vm._v("Не был распечатан")])])]) : _vm._e(), _vm._v(" "), (_vm.document.last_email) ? _c('div', [_c('span', [_vm._v(_vm._s('Последняя отправка: '))]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.moment(_vm.document.last_email.created_at).format('DD.MM.YYYY')) + ", " + _vm._s(_vm.document.last_email.success == '1' ? 'доставлено' : 'не доставлено'))]), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "bottom",
      "md-delay": "500"
    }
  }, [_vm._v(" Отправлено " + _vm._s(_vm.document.last_email.user.login) + " (" + _vm._s(_vm.document.last_email.user.id) + ") на " + _vm._s(_vm.document.last_email.email))])], 1) : _vm._e(), _vm._v(" "), (_vm.document.agent && _vm.document.agent.id) ? _c('div', [_c('span', [_vm._v(_vm._s('Принципал: ' + _vm.document.agent.name + ((_vm.document.agent.inn) ? (', ' + _vm.document.agent.inn) : ((_vm.document.agent.passport_number) ? (', ' + _vm.document.agent.passport_number) : ''))))])]) : _vm._e(), _vm._v(" "), (_vm.document.customer && _vm.document.customer.id) ? _c('div', [_c('span', [_vm._v(_vm._s('Контрагент: ' + _vm.document.customer.inn + ', ' + _vm.document.customer.name))])]) : _vm._e()]), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.editDialog
    },
    on: {
      "update:active": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Редактирование документа")]), _vm._v(" "), _c('template', {
    slot: "default"
  }, [((!_vm.deal.executor || parseInt(_vm.deal.executor.nds) !== 0) && _vm.editDoc.agent_id) ? _c('div', [_c('div', [_vm._v(" Внимание, выбран исполнитель с НДС! ")]), _vm._v(" "), _c('div', [_vm._v(" Указание принципала возможно только для исполнителя БЕЗ НДС. ")]), _vm._v(" "), _c('div', [_vm._v(" Если документ был создан до изменения исполнителя, ")]), _vm._v(" "), _c('div', [_vm._v(" выберете пункт \"Без принципала\" (текущий принципал будет удалён из документа) ")])]) : _vm._e(), _vm._v(" "), _c('div', [((['invoice_a4', 'act_a4'].indexOf(_vm.editDoc.type) + 1)) ? _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "agent_id",
      "name": "agent_id",
      "label": "Принципал",
      "data-vv-as": " ",
      "data-vv-name": "agent_id",
      "data-vv-scope": "agent",
      "error": _vm.errors.first('agent.agent_id')
    },
    model: {
      value: (_vm.editDoc.agent_id),
      callback: function($$v) {
        _vm.$set(_vm.editDoc, "agent_id", $$v)
      },
      expression: "editDoc.agent_id"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(" Без принципала ")]), _vm._v(" "), _vm._l((_vm.agents), function(item) {
    return ((_vm.deal.executor && parseInt(_vm.deal.executor.nds) === 0) || parseInt(item.id) === parseInt(_vm.editDoc.agent_id)) ? _c('option', {
      key: item.id,
      attrs: {
        "disabled": (!_vm.deal.executor || parseInt(_vm.deal.executor.nds) !== 0)
      },
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), ((['invoice_a4', 'invoice'].indexOf(_vm.editDoc.type) + 1)) ? _c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "id": "act_id",
      "name": "act_id",
      "label": "Прикреплённый акт",
      "data-vv-as": " ",
      "data-vv-name": "act_id",
      "data-vv-scope": "related",
      "error": _vm.errors.first('related.act_id')
    },
    model: {
      value: (_vm.editDoc.act_id),
      callback: function($$v) {
        _vm.$set(_vm.editDoc, "act_id", $$v)
      },
      expression: "editDoc.act_id"
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Не выбран")]), _vm._v(" "), _vm._l((_vm.acts), function(item) {
    return _c('option', {
      key: ("related-" + (item.id)),
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.label))])
  })], 2) : _vm._e(), _vm._v(" "), _c('z-date', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.dateValidationRules),
      expression: "dateValidationRules"
    }],
    attrs: {
      "placeholder": "Дата платежа",
      "required": "",
      "label": "Дата создания",
      "return-string": false,
      "format": "DD.MM.YYYY HH:mm:ss",
      "type": "datetime",
      "data-vv-name": "date",
      "data-vv-as": ' ',
      "error": (_vm.errors.first('date') ? ('Укажите корректную дату (между датой создания заявки и датой выдачи груза клиенту)') : null)
    },
    model: {
      value: (_vm.editDoc.created_at),
      callback: function($$v) {
        _vm.$set(_vm.editDoc, "created_at", $$v)
      },
      expression: "editDoc.created_at"
    }
  })], 1)]), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('z-button', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v(" Отмена ")]), _vm._v(" "), _c('z-button', {
    attrs: {
      "primary": "",
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.editDocument()
      }
    }
  }, [_vm._v(" Сохранить ")])], 1)], 2), _vm._v(" "), _c('ZDialog', {
    attrs: {
      "active": _vm.sendDocDialog
    },
    on: {
      "update:active": function($event) {
        _vm.sendDocDialog = $event
      }
    }
  }, [_c('template', {
    slot: "title"
  }, [_vm._v("Отправка документа")]), _vm._v(" "), _c('template', {
    slot: "default"
  }, [_c('z-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "id": "document-recipient",
      "name": "document_recipient",
      "label": "E-mail получателя",
      "error": _vm.errors.first('document_recipient')
    },
    model: {
      value: (_vm.documentRecipient),
      callback: function($$v) {
        _vm.documentRecipient = $$v
      },
      expression: "documentRecipient"
    }
  }, [_vm._l((_vm.contacts), function(contact) {
    return _c('option', {
      key: contact.id,
      domProps: {
        "value": contact.id
      }
    }, [_vm._v(" " + _vm._s(contact.email) + " " + _vm._s(contact.name ? '(' + contact.type_name + ')' : '') + " ")])
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "other"
    }
  }, [_vm._v(" Другой... ")])], 2), _vm._v(" "), (_vm.documentRecipient == 'other') ? _c('z-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('email|required'),
      expression: "'email|required'"
    }],
    attrs: {
      "label": "Ваш e-mail",
      "name": "document_recipient_other",
      "id": "document-recipient-other",
      "error": _vm.errors.first('document_recipient_other'),
      "data-vv-name": "document_recipient_other",
      "data-vv-as": ' '
    },
    model: {
      value: (_vm.documentRecipientOther),
      callback: function($$v) {
        _vm.documentRecipientOther = $$v
      },
      expression: "documentRecipientOther"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('template', {
    slot: "actions"
  }, [_c('z-button', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.sendDocDialog = false
      }
    }
  }, [_vm._v(" Отмена ")]), _vm._v(" "), _c('z-button', {
    attrs: {
      "primary": "",
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.sendDoc()
      }
    }
  }, [_vm._v(" Отправить ")])], 1)], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec739a92","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/deals/views/components/Doc.vue
// module id = 1275
// module chunks = 0